<div class="form-check d-flex align-items-start position-relative">
  <div class="d-flex align-items-center form-check">
    <input
      (change)="onValueChange($event.target?.checked)"
      [checked]="value"
      [value]="value"
      autocomplete="off"
      class="my-auto form-check-input flex-shrink-0"
      id="term-agreement-checkbox"
      type="checkbox"
    />

    <label
      class="form-check-label ms-2"
      for="term-agreement-checkbox"
    >
      {{ 'I hereby agree to the' | translate }}

      <a
        [value]="termOfUseUrl"
        class="jip-login__text-underline"
        target="_blank"
        rel="noopener"
        appUrlPrefix
      >
        {{ 'UI.TermsOfUse' | translate }}
      </a>

      {{ 'Of-JointCreate.Com' | translate: { portalName: portalName } }}
    </label>
  </div>
</div>
